import { Box } from "@mui/material";
import type { BalancesProps } from "Components/Dashboard/BalanceWithPaymentActions/types";
import { Balance } from "Components/Shared/Balance";

/**
 * Desktop shows the selected currency only; the switcher and the eye toggle live in the card
 * header (DesktopBalanceHeader), so the container hands this renderer no toggle.
 */
export const DesktopCurrencyBalance = ({
  balances,
  selectedCurrency,
  isBalanceBlurred,
}: BalancesProps) => {
  const shown =
    balances.find(({ currency }) => currency === selectedCurrency) ??
    balances[0];

  return (
    <Box
      sx={{
        filter: isBalanceBlurred ? "blur(8px)" : "none",
        pointerEvents: isBalanceBlurred ? "none" : "auto",
        userSelect: isBalanceBlurred ? "none" : "auto",
        transition: "filter 0.15s ease",
      }}
    >
      <Balance balance={shown?.total ?? 0} currency={shown?.currency} />
    </Box>
  );
};
